export default {
  base: 'vs-dark',
  inherit: true,
  rules: [
    { token: '', foreground: 'd9d7ce' },
    { token: 'invalid', foreground: 'ff3333' },
    { token: 'emphasis', fontstyle: 'italic' },
    { token: 'strong', fontstyle: 'bold' },

    { token: 'variable', foreground: 'd9d7ce' },
    { token: 'variable.predefined', foreground: 'd9d7ce' },
    { token: 'constant', foreground: 'ff9d45' },
    { token: 'comment', foreground: '5c6773', fontstyle: 'italic' },
    { token: 'number', foreground: 'ff9d45' },
    { token: 'number.hex', foreground: 'ff9d45' },
    { token: 'regexp', foreground: '95e6cb' },
    { token: 'annotation', foreground: '5ccfe6' },
    { token: 'type', foreground: '5ccfe6' },

    { token: 'delimiter', foreground: 'd9d7ce' },
    { token: 'delimiter.html', foreground: 'd9d7ce' },
    { token: 'delimiter.xml', foreground: 'd9d7ce' },

    { token: 'tag', foreground: '80d4ff' },
    { token: 'tag.id.jade', foreground: '80d4ff' },
    { token: 'tag.class.jade', foreground: '80d4ff' },
    { token: 'meta.scss', foreground: '80d4ff' },
    { token: 'metatag', foreground: '80d4ff' },
    { token: 'metatag.content.html', foreground: 'bae67e' },
    { token: 'metatag.html', foreground: '80d4ff' },
    { token: 'metatag.xml', foreground: '80d4ff' },
    { token: 'metatag.php', fontstyle: 'bold' },

    { token: 'key', foreground: '5ccfe6' },
    { token: 'string.key.json', foreground: '5ccfe6' },
    { token: 'string.value.json', foreground: 'bae67e' },

    { token: 'attribute.name', foreground: '5ccfe6' },
    { token: 'attribute.value', foreground: 'bae67e' },
    { token: 'attribute.value.number', foreground: 'ff9d45' },
    { token: 'attribute.value.unit', foreground: 'bae67e' },
    { token: 'attribute.value.html', foreground: 'bae67e' },
    { token: 'attribute.value.xml', foreground: 'bae67e' },

    { token: 'string', foreground: 'bae67e' },
    { token: 'string.html', foreground: 'bae67e' },
    { token: 'string.sql', foreground: 'bae67e' },
    { token: 'string.yaml', foreground: 'bae67e' },

    { token: 'keyword', foreground: 'ffae57' },
    { token: 'keyword.json', foreground: 'ffae57' },
    { token: 'keyword.flow', foreground: 'ffae57' },
    { token: 'keyword.flow.scss', foreground: 'ffae57' },

    { token: 'operator.scss', foreground: '666666' }, //
    { token: 'operator.sql', foreground: '778899' }, //
    { token: 'operator.swift', foreground: '666666' }, //
    { token: 'predefined.sql', foreground: 'ff00ff' },
  ], //],
  colors: {
    focusBorder: '#F7F7F700',
    foreground: '#D8DEE9',
    'widget.shadow': '#1B2B3450',
    errorForeground: '#EC5f67',
    'textBlockQuote.background': '#1B2B34',
    'textBlockQuote.border': '#1B2B34',
    'textCodeBlock.background': '#273942',
    'textLink.activeForeground': '#D8DEE9',
    'textLink.foreground': '#80CBC4',
    'button.background': '#80CBC4',
    'button.foreground': '#000000',
    'button.hoverBackground': '#6699CC',
    'dropdown.background': '#273942',
    'dropdown.listBackground': '#273942',
    'dropdown.border': '#273942',
    'dropdown.foreground': '#D8DEE9',
    'input.background': '#1B2B34',
    'input.border': '#273942',
    'input.foreground': '#F7F7F7',
    'input.placeholderForeground': '#607d8b',
    'scrollbar.shadow': '#1B2B3470',
    'badge.foreground': '#000000',
    'badge.background': '#D8DEE9',
    'progressBar.background': '#80CBC4',
    'list.activeSelectionBackground': '#607d8b50',
    'list.activeSelectionForeground': '#80CBC4',
    'list.dropBackground': '#607d8b50',
    'list.focusBackground': '#607d8b50',
    'list.hoverBackground': '#607d8b20',
    'list.hoverForeground': '#D8DEE9',
    'list.inactiveSelectionBackground': '#607d8b30',
    'list.inactiveSelectionForeground': '#80CBC4',
    'activityBar.background': '#1B2B34',
    'activityBar.dropBackground': '#607d8b30',
    'activityBar.foreground': '#F7F7F7',
    'activityBar.inactiveForeground': '#607d8b',
    'activityBar.border': '#80CBC430',
    'activityBarBadge.background': '#80CBC4',
    'activityBarBadge.foreground': '#000000',
    'activityBar.activeBorder': '#80CBC4',
    'sideBar.background': '#1B2B34',
    'sideBar.foreground': '#607d8b',
    'sideBar.border': '#80CBC430',
    'sideBar.dropBackground': '#1B2B3430',
    'sideBarTitle.foreground': '#D8DEE9',
    'sideBarSectionHeader.background': '#1B2B34',
    'sideBarSectionHeader.foreground': '#D8DEE9',
    'sideBarSectionHeader.border': '#80CBC430',
    'editorGroup.border': '#1B2B3430',
    'editorGroupHeader.tabsBackground': '#1B2B34',
    'editorGroupHeader.noTabsBackground': '#1B2B34',
    'tab.activeBorder': '#80CBC4',
    'tab.activeForeground': '#F7F7F7',
    'tab.activeBackground': '#273942',
    'tab.activeModifiedBorder': '#607d8b',
    'tab.hoverBackground': '#273942',
    'tab.border': '#1B2B34',
    'tab.inactiveBackground': '#1B2B34',
    'tab.inactiveForeground': '#607d8b',
    'tab.unfocusedActiveBorder': '#607d8b',
    'tab.unfocusedActiveForeground': '#D8DEE9',
    'editor.background': '#273942',
    'editor.foreground': '#D8DEE9',
    'editorLineNumber.foreground': '#4E5D65',
    'editorLineNumber.activeForeground': '#AFBDC4',
    'editorCursor.foreground': '#F9AE58',
    'editor.selectionBackground': '#607d8b80',
    'editor.inactiveSelectionBackground': '#80CBC410',
    'editor.selectionHighlightBackground': '#80CBC415',
    'editor.selectionHighlightBorder': '#00000000',
    'editor.wordHighlightBackground': '#6699CC25',
    'editor.wordHighlightBorder': '#00000000',
    'editor.findMatchBackground': '#F9875775',
    'editor.findMatchHighlightBackground': '#F9AE5875',
    'editor.findMatchBorder': '#00000000',
    'editor.findMatchHighlightBorder': '#00000000',
    'editor.findRangeHighlightBorder': '#00000000',
    'editor.hoverHighlightBackground': '#80CBC420',
    'editor.lineHighlightBackground': '#00000000',
    'editor.lineHighlightBorder': '#00000000',
    'editorLink.activeForeground': '#00000000',
    'editorIndentGuide.background': '#4E5D6530',
    'editorIndentGuide.activeBackground': '#AFBDC430',
    'editorBracketMatch.background': '#6699CC50',
    'editorBracketMatch.border': '#00000000',
    'editorOverviewRuler.border': '#1B2B34',
    'editorOverviewRuler.modifiedForeground': '#6699CC50',
    'editorOverviewRuler.addedForeground': '#99C79450',
    'editorOverviewRuler.deletedForeground': '#EC5f6750',
    'editorOverviewRuler.errorForeground': '#EC5f6780',
    'editorOverviewRuler.warningForeground': '#FAC86350',
    'editorError.foreground': '#EC5f6790',
    'editorError.border': '#00000000',
    'editorWarning.foreground': '#FAC86370',
    'editorWarning.border': '#00000000',
    'editorInfo.foreground': '#AFBDC490',
    'editorInfo.border': '#00000000',
    'editorHint.foreground': '#AFBDC490',
    'editorHint.border': '#00000000',
    'editorUnnecessaryCode.border': '#607d8b',
    'editorGutter.background': '#273942',
    'editorGutter.modifiedBackground': '#6699CC50',
    'editorGutter.addedBackground': '#99C79450',
    'editorGutter.deletedBackground': '#EC5f6750',
    'editorSuggestWidget.background': '#1B2B34',
    'editorSuggestWidget.border': '#1B2B3410',
    'editorSuggestWidget.foreground': '#D8DEE9',
    'editorSuggestWidget.highlightForeground': '#80CBC4',
    'editorSuggestWidget.selectedBackground': '#00000050',
    'editorWhitespace.foreground': '#D8DEE935',
    'editorWidget.background': '#1B2B34',
    'editorWidget.border': '#1B2B34',
    'editorWidget.resizeBorder': '#80CBC4',
    'menu.foreground': '#D8DEE9',
    'menu.background': '#1B2B34',
    'menu.selectionForeground': '#F7F7F7',
    'menu.selectionBackground': '#607d8b50',
  },
};
